import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal'
import { Box, DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Typography from '@mui/material/Typography'
import { useForm } from 'react-hook-form'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'

import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { makeGetRequest } from 'utils/api'
import urls from 'utils/urls'
import ListItemText from '@mui/material/ListItemText'
import Checkbox from '@mui/material/Checkbox'
import CreateContact from './CreateContact'
import { width } from '@fortawesome/free-solid-svg-icons/faInfo'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

const mstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 500,
  borderRadius: 2,

  bgcolor: 'background.paper',
  boxShadow: 24,
}

export default function AddContact({ setShowContactModel, checkListContacts }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modelOpen, setModelOpen] = useState(true)
  const [personName, setPersonName] = useState([])
  const [contacts, setContacts] = useState([])
  const [contactModelOpen, setContactModelOpen] = useState(false)
  const handleModelClose = () => {
    setModelOpen(false)
    setShowContactModel(false)
  }

  useEffect(() => {
    fetchContacts()
  }, [])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    setPersonName(typeof value === 'string' ? value.split(',') : value)
  }
  const { handleSubmit, control } = useForm({
    defaultValues: {},
  })

  const fetchContacts = async () => {
    const url = urls.getAllContacts + '?limit=100000'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterTypes = []
      data.forEach((v) => {
        filterTypes.push({ label: `${v.Nom} ${v.Prenom}`, id: v.id })
      })
      setContacts([...filterTypes])
    }
  }

  const onSubmit = async (data) => {
    let val = []
    personName.filter((n) => {
      let i = contacts.filter((v) => v.label === n)
      val.push(i[0].id)
      return ''
    })
    checkListContacts(val)
    handleModelClose()
  }

  return (
    <>
      <Modal
        open={modelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ '.ccmodel': { width: isMobile ? '90%' : '500px' } }}
      >
        <Box sx={mstyle} className="ccmodel">
          <Box>
            <Box
              sx={{ textAlign: 'end', padding: '5px 10px', position: 'relative', zIndex: '999' }}
            >
              <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleModelClose} />
            </Box>
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: '-30px',
                }}
              >
                <Box sx={{ width: '-webkit-fill-available' }}>
                  <Typography
                    id="modal-modal-title"
                    sx={{ color: 'black !important' }}
                    variant="h6"
                    component="h3"
                  >
                    Affecter contact
                  </Typography>
                  <Box>
                    <DialogContent>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '-webkit-fill-available',
                        }}
                      >
                        <Box sx={{ width: '-webkit-fill-available' }}>
                          <FormControl sx={{ width: '-webkit-fill-available' }}>
                            <InputLabel id="contact-select">{t('mesToDo.contactsSelect')}</InputLabel>
                            <Select
                              control={control}
                              labelId="contact-select"
                              id="cles-multiple-checkbox"
                              multiple
                              name="contact"
                              value={personName}
                              onChange={handleChange}
                              input={<OutlinedInput label={t('mesToDo.contactsSelect')} />}
                              renderValue={(selected) => selected.join(', ')}
                              sx={{
                                '& #cles-multiple-checkbox': {
                                  padding: '10px 14px',
                                },
                              }}
                            >
                              {contacts.map((v) => (
                                <MenuItem key={v.id} value={v.label}>
                                  <Checkbox checked={personName.indexOf(v.label) > -1} />
                                  <ListItemText primary={v.label} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>
                        <Box
                          sx={{
                            display: 'flex',
                            marginTop: '10px',
                            marginLeft: '5px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '0',
                            '& button': { minWidth: '0', color: '#434343', padding: '0' },
                          }}
                        >
                          <Button onClick={() => setContactModelOpen(true)}>
                            <AddIcon />
                          </Button>
                        </Box>
                      </Box>
                    </DialogContent>
                    <DialogActions>
                      <Button sx={{ marginLeft: 'auto !important' }} onClick={onSubmit}>
                        {t('mesToDo.validate')}
                      </Button>
                    </DialogActions>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      {contactModelOpen && (
        <CreateContact fetchContacts={fetchContacts} setContactModelOpen={setContactModelOpen} />
      )}
    </>
  )
}
